import React from 'react';
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { useSEO } from "@/hooks/useSEO";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { faqItems } from '@/data/faqItems';

const FAQ = () => {
  useSEO({
    title: 'FAQ - Female Partner Calculator | Common Questions & Answers',
    description: 'Get answers to frequently asked questions about the Female Partner Calculator statistical tool. Learn about data accuracy, methodology, and result interpretation.',
    keywords: 'female partner calculator FAQ, dating calculator questions, compatibility tool help, statistical dating advice',
    canonical: 'https://femalepartnercalculator.com/faq',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqItems.map((item) => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer,
        },
      })),
    }
  });

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <Breadcrumbs />
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold tracking-tight">
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-muted-foreground">
              Common questions about the Female Partner Calculator statistical tool
            </p>
          </div>

          <main className="container mx-auto px-4 py-8">
            <Card className="max-w-4xl mx-auto">
              <CardHeader>
                <CardTitle>FAQ</CardTitle>
                <CardDescription>
                  Get answers to the most commonly asked questions about our statistical compatibility calculator
                </CardDescription>
              </CardHeader>
              <CardContent>
                {/* All items default-open so answers are present in prerendered HTML */}
                <Accordion
                  type="multiple"
                  defaultValue={faqItems.map((_, index) => `item-${index + 1}`)}
                  className="w-full"
                >
                  {faqItems.map((item, index) => (
                    <AccordionItem key={index} value={`item-${index + 1}`}>
                      <AccordionTrigger>{item.question}</AccordionTrigger>
                      <AccordionContent>{item.answer}</AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </CardContent>
            </Card>

            <div className="mt-8 text-center space-y-3">
              <p className="text-muted-foreground">
                Ready to run your numbers? Try one of our calculators:
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/" className="text-primary hover:underline font-medium">
                  Female Partner Calculator →
                </Link>
                <Link to="/ideal-woman-calculator" className="text-primary hover:underline font-medium">
                  Ideal Woman Calculator →
                </Link>
                <Link to="/male-partner-calculator" className="text-primary hover:underline font-medium">
                  Male Partner Calculator →
                </Link>
                <Link to="/dating-standards-calculator" className="text-primary hover:underline font-medium">
                  Dating Standards Test →
                </Link>
              </div>
            </div>
          </main>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default FAQ;
